import React, { useEffect, useRef, useState } from "react";
import "./FilterStatusSelect.scss";
import DownArrowIcon from "../../../../../components/icons/DownArrowIcon";
import { TemplatesApi } from "../../../../../utils/api/Templates";
import toast from "react-hot-toast";

const FilterFestivalType = ({ formik }: { formik: any }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [festivalOptions, setFestivalOptions] = useState<any[]>([]);
  const [filteredOptions, setFilteredOptions] = useState<any[]>([]);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const fetchFestivalTypes = async () => {
    try {
      setLoading(true);
      const res = await TemplatesApi.getFestivalTypes({
        search: "",
        page: 1,
        limit: 200,
        created_at: "desc",
      });

      const list = res?.data?.data?.docs || [];
      setFestivalOptions(list);
      setFilteredOptions(list);
    } catch (err) {
      toast.error("Failed to load festival types");
      console.error("Error fetching festival types:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFestivalTypes();
  }, []);

  const selectedLabel =
    festivalOptions.find((item) => item.slug === formik?.values?.festival_type)
      ?.name || "Select Festival Type";

  const handleSelect = (slug: string) => {
    formik.setFieldValue("festival_type", slug);
    setDropdownOpen(false);
    setSearchText("");
    setFilteredOptions(festivalOptions);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const filtered = festivalOptions.filter((item) =>
      item.name.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredOptions(filtered);
  }, [searchText, festivalOptions]);

  return (
    <div className="agent-festival-contain-container" ref={containerRef}>
      <div className="agent-heading">
        <p>Festival Type</p>
      </div>

      <div className="filter-search-listing">
        <input
          type="text"
          placeholder="Select Festival Type"
          className="filter-search-input"
          value={dropdownOpen ? searchText : selectedLabel}
          onClick={() => setDropdownOpen(true)}
          onChange={(e) => {
            if (dropdownOpen) setSearchText(e.target.value);
          }}
          readOnly={!dropdownOpen}
        />
        <div
          className={`filter-down-arrow-icon ${dropdownOpen ? "open-box" : ""}`}
          onClick={() => {
            setDropdownOpen(!dropdownOpen);
            if (!dropdownOpen) setSearchText("");
          }}
        >
          <DownArrowIcon />
        </div>
      </div>

      {dropdownOpen && (
        <div className="review-list-container">
          {loading && <p className="item-profile-name">Loading...</p>}

          {!loading &&
            filteredOptions.map((item) => (
              <div
                key={item.slug}
                className={`agent-list-item ${
                  formik.values.festival_type === item.slug
                    ? "agent-list-item-active"
                    : ""
                }`}
                onClick={() => handleSelect(item.slug)}
              >
                <p className="item-profile-name">{item.name}</p>
              </div>
            ))}

          {!loading && filteredOptions.length === 0 && (
            <p className="no-item-found">No festival found</p>
          )}
        </div>
      )}
    </div>
  );
};

export default FilterFestivalType;
